var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('van-nav-bar',{attrs:{"title":_vm.$route.meta.title,"fixed":true,"placeholder":true,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }